// extracted by mini-css-extract-plugin
export var link = "breadcrumbs-module--link--dbb29";
export var space = "breadcrumbs-module--space--4fb7d";
export var wrapper = "breadcrumbs-module--wrapper--66ecd";